import { ProgressBar } from 'melp-design/components';
import { CellProps } from 'react-table';

const ProgressBarCell = (props: CellProps<{}, number | string>) => {
  const valueAsNumber = Number(props.value);
  return <ProgressBar value={valueAsNumber} color="success" />;
};

export default ProgressBarCell;
